import { onMounted, onUnmounted, ref } from 'vue';
import { detectMobile } from '../utils/mobile-detection';
import { debounce } from '../utils/debounce';

/** Mobile detection mixin. */
export function useMobileDetection() {
  const isMobile = ref(false);

  /**
   * Handle window size change with debounce helper.
   * @returns {void}
   */
  const handleWindowSizeChange = debounce(() => {
    isMobile.value = detectMobile();
  }, 100);

  onMounted(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    handleWindowSizeChange();
  });

  onUnmounted(() => {
    window.removeEventListener('resize', handleWindowSizeChange);
  });

  return {
    isMobile,
  };
}
